"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determines the color of the life cycle status icon and text.
 */
var StatusType;
(function (StatusType) {
    /**
     * Blue.
     */
    StatusType[StatusType["Info"] = 0] = "Info";
    /**
     * Grey.
     */
    StatusType[StatusType["Muted"] = 1] = "Muted";
    /**
     * Green.
     */
    StatusType[StatusType["Success"] = 2] = "Success";
    /**
     * Orange.
     */
    StatusType[StatusType["Warning"] = 3] = "Warning";
    /**
     * Red.
     */
    StatusType[StatusType["Danger"] = 4] = "Danger";
})(StatusType = exports.StatusType || (exports.StatusType = {}));
/**
 * Determines the shape of the large status icon on a detail page
 */
var StatusShape;
(function (StatusShape) {
    /**
     * Circle.
     */
    StatusShape[StatusShape["Circle"] = 0] = "Circle";
    /**
     * Square.
     */
    StatusShape[StatusShape["Square"] = 1] = "Square";
    /**
     * Hexagon.
     */
    StatusShape[StatusShape["Hexagon"] = 2] = "Hexagon";
    /**
     * Stack.
     */
    StatusShape[StatusShape["Stack"] = 3] = "Stack";
    /**
     * Image
     */
    StatusShape[StatusShape["Image"] = 4] = "Image";
})(StatusShape = exports.StatusShape || (exports.StatusShape = {}));
/**
 * Mapping for icon and text colors.
 */
exports.getStyles = function (statusType) {
    switch (statusType) {
        case StatusType.Success:
            return {
                text: "",
                icon: "oui-text-success",
                badge: "oui-label-success",
                statusBadge: "oui-status-badge__status-good"
            };
        case StatusType.Warning:
            return {
                text: "",
                icon: "oui-text-warning",
                badge: "oui-label-warning",
                statusBadge: "oui-status-badge__status-warning"
            };
        case StatusType.Danger:
            return {
                text: "oui-text-danger",
                icon: "oui-text-danger",
                badge: "oui-label-danger",
                statusBadge: "oui-status-badge__status-error"
            };
        case StatusType.Info:
            return {
                text: "oui-text-info",
                icon: "oui-text-info",
                badge: "oui-label-info",
                statusBadge: "oui-status-badge__status-info"
            };
        case StatusType.Muted:
        default:
            return {
                text: "",
                icon: "oui-status-label--muted",
                badge: "oui-label-muted",
                statusBadge: "oui-status-badge__status-unknown"
            };
    }
};
//# sourceMappingURL=status.js.map